import React, { Component, Fragment } from 'react';
import classnames from 'classnames';
import { Button, } from 'reactstrap';

export default class ListForm extends Component {
  constructor() {
    super();
    this.state = {};
  }
  onClickAdd = () => {
    const { items, onChange, initialItem = _ => ({}), } = this.props;
    onChange([...items, initialItem(items)], items);
  }
  onClickDelete = (index) => {
    const { items, onChange } = this.props;
    onChange([...items.slice(0, index), ...items.slice(index + 1)], items);
  }
  render() {
    const { items, renderItem, itemClassName, deleteDisabled = false, addButtonLabel = '追加', disabled = false, renderFooterContent = _ => _, } = this.props;
    return (
      <Fragment>
        {
          items.map((item, i) => {
            return (
              <div key={i} className={classnames('d-flex mb-2 align-items-start', itemClassName)}>
                <div className="mr-1 flex-grow-1">
                  {renderItem(item, i)}
                </div>
                {
                  !disabled && !deleteDisabled && (
                    <Button color="danger" onClick={this.onClickDelete.bind(this, i)}>
                      <span className="fas fa-trash" />
                    </Button>
                  )
                }
              </div>
            )
          })
        }
        {
          !disabled && (
            <div>
              {
                renderFooterContent((
                  <Button color="secondary" onClick={this.onClickAdd}>
                    <span className="fas fa-plus mr-1" />
                    {addButtonLabel}
                  </Button>
                ))
              }
            </div>
          )
        }
      </Fragment>
    );
  }
};
